export default __webpack_public_path__ + "static/media/logotagline.a5b6261b.png";